module.exports = __webpack_public_path__ + "img/Yellow-L-1@2x.a625f122.png";